import ModerationView from './view';

export default ModerationView;



// WEBPACK FOOTER //
// ./src/components/elements/moderationView/index.js